// initial state
const state = {
    open: false,
    metaInfo: null,
}

// getters
const getters = {
    
}

// actions
const actions = {
    show(context, payload) {
        context.commit('setMeta', payload);
        context.commit('updateOpen', true);
    },
    hide(context) {
        context.commit('updateOpen', false);
    }
}

// mutations
const mutations = {
    setMeta(state, payload) {
        state.metaInfo = payload;
    },
    updateOpen(state, open) {
        state.open = open;
    },
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/file.js